import { render, staticRenderFns } from "./EditMode.vue?vue&type=template&id=878c8baa&scoped=true&"
import script from "./EditMode.vue?vue&type=script&lang=js&"
export * from "./EditMode.vue?vue&type=script&lang=js&"
import style0 from "./EditMode.vue?vue&type=style&index=0&id=878c8baa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "878c8baa",
  null
  
)

export default component.exports